import PropTypes from "prop-types";
import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage/index.jsx";
import SignInPage from "../pages/UserManagement/SignInPage.jsx";
import SignUpPage from "../pages/UserManagement/SignUpPage.jsx";
import ForgotPasswordPage from "../pages/UserManagement/ForgotPasswordPage.jsx";
import ResetPasswordPage from "../pages/UserManagement/ResetPasswordPage.jsx";
import OAuthConsentPage from "../pages/UserManagement/OAuthConsentPage.jsx";

// import Register from "../pages/Register";
import ProtectedRoute from "./ProtectedRoute";
import Workspace from "../pages/MainPanel/index.jsx";
import Changelog from "../pages/ChangeLog";

/**
 * AppRoutes component for defining all application routes
 * Centralizes route configuration and makes it easier to manage
 * @param {Object} props - Component props
 * @param {Object} props.user - Current user object
 */
const AppRoutes = ({ user }) => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signin" element={<SignInPage user={user} />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/oauth/consent" element={<OAuthConsentPage user={user} />} />
      <Route path="/changelog" element={<Changelog />} />

      {/* Protected routes requiring authentication */}
      <Route element={<ProtectedRoute user={user} />}>
        <Route path="/workspace" element={<Workspace user={user} />} />
      </Route>
    </Routes>
  );
};

AppRoutes.propTypes = {
  user: PropTypes.object,
};

export default AppRoutes;
